import Lightbox from 'utils/_lightbox'

const $ = jQuery

export default function ImageCardsLightbox () {
  const IMAGE_CARD_WRAPPERS = document.querySelectorAll('.mtt-image-cards')

  if (IMAGE_CARD_WRAPPERS.length) {
    for (let i = 0; i < IMAGE_CARD_WRAPPERS.length; i++) {
      const IMAGE_CARD_WRAPPER = IMAGE_CARD_WRAPPERS[i]
      addLightBoxes(IMAGE_CARD_WRAPPER)
    }
  }

  function addLightBoxes(cardWrapper) {
    const CARDS = cardWrapper.querySelectorAll('.image-card')

    if (!CARDS.length) {
      return
    }

    new Lightbox(CARDS)
  }
}
